import React from 'react';

// KHAN audit FP-013/FQ-005: no ErrorBoundary existed anywhere in the app, so
// any uncaught render error left the user staring at a blank white page with
// no way to recover short of manually reloading.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Unhandled render error caught by ErrorBoundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="container text-center mt-5">
          <h1>Oops! Something went wrong.</h1>
          <p>We are having trouble showing this page. Please try reloading.</p>
          <button
            onClick={() => window.location.reload()}
            className="btn btn-primary"
          >
            Reload page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
